"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");

var ConstraintTypeEnum_1 = require("../../model/constraint/ConstraintTypeEnum");
/**
 * Abstract {@link Constraint single constraint} converter.
 *
 * @author RV
 */


var AbstractConstraintConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(AbstractConstraintConverter, _DataObjectConverter_);

  function AbstractConstraintConverter() {
    _classCallCheck(this, AbstractConstraintConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(AbstractConstraintConverter).apply(this, arguments));
  }

  _createClass(AbstractConstraintConverter, [{
    key: "deserializeConstraintType",

    /**
     * Deserializes {@link ConstraintTypeEnum type} of constraint.
     *
     * @param constraintDocument serialized constraint
     * @param conversions implementation of DataObjectConversions
     */
    value: function deserializeConstraintType(constraintDocument, conversions) {
      return conversions.asEnum(constraintDocument.constraintType, ConstraintTypeEnum_1.ConstraintTypeEnum);
    }
  }]);

  return AbstractConstraintConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.AbstractConstraintConverter = AbstractConstraintConverter;